module.exports = __webpack_public_path__ + "img/image5.2f6c4890.png";